module.exports = function(app) {
    app.controller("pages.spending.debitCard", ["$scope", "session","services", "storage","coremetrics","spendingResourceServices","$cookies","invisibleForm",'educationalMaterialService',
        function( $scope, session,services, storage,coremetrics, spendingResourceServices,$cookies,invisibleForm,educationalMaterialService) {


            $scope.educationalDrawer = false;

            var memberInfo = session.data.memberInfo;
            var spendingAccountDebitCard = function (fullMemberInfo) {
                fullMemberInfo = fullMemberInfo || session.data.memberInfo;
                var clientDebitObj = {};
                var clientDebitList = [];
                var today = new Date();
                today.setHours(0);
                today.setMinutes(0);
                today.setSeconds(0);
                today.setMilliseconds(0);
                for (var i = 0; i < fullMemberInfo.clientList.length; i++) {
                    var client = fullMemberInfo.clientList[i];
                    for (var j = 0; j < client.groupList.length; j++) {
                        var group = client.groupList[j];
                        if (group.spendingAccountExistsIndicator && group.spendingAccountExistsIndicator === "true") {
                            var productList = group.productList; //product list
                            for (var k = 0; k < productList.length; k++) {
                                var product = productList[k];
                                if (productList[k].benefitPlanType === "Spending Accounts") {
                                    var memberList = productList[k].memberList; //member list
                                    var isSubscriber = false;
                                    for (var l = 0; l < memberList.length; l++) {
                                        if ( memberList[l].relationship === "Subscriber") {
                                            isSubscriber = true;
                                            clientDebitObj.clientName = client.clientName;
                                            clientDebitObj.clientNumber = client.clientNumber;
                                            clientDebitObj.groupNumber = group.groupNumber;
                                        }
                                    }
                                    if(isSubscriber){
                                        var coverageBeginDate = new Date(product.coverageBeginDate);
                                       // var coverageEndDate = new Date(product.coverageEndDate);
                                        if (today >= coverageBeginDate) {
                                            console.log(product.benefitPlanName);
                                            clientDebitObj.accountName = product.benefitPlanName;
                                            clientDebitList.push(clientDebitObj);
                                        }
                                    }
                                }
                            }
                            break;
                        }
                    }
                }
                return clientDebitList;
            };
            $scope.clientDebitList = spendingAccountDebitCard(memberInfo);
            var umi = memberInfo.umi + '0';
            $scope.ssoToSpendingDebitCard = function () {
                var acclarisSsoClientNumber = $cookies.get('mbrClientNumber');

                var thePayload = {
                    groupId: acclarisSsoClientNumber,
                    memberId: umi,
                    csr: false,
                    DLParams: 'obj~EEPRFLSMRYPAGE-Page',
                    userRole: 'MEMBER'
                };

                coremetrics.elementTag('MEMBER:CLAIMS AND SPENDING:ACCLARIS SSO', 'MEMBER:CLAIMS AND SPENDING');

                services.rbsmbl.acclaris().postData({payload: thePayload}).then(function (success) {
                    var ssoFormConfig = {
                        name: 'acclarisSSOpriorYearForm',
                        id: 'acclarisSSOpriorYearFormId',
                        formTarget: 'InvisibleSsoSvcs',
                        method: 'POST',
                        action: success.data.payload.redirectionURL + '?cm_sp=SPENDING%20SSO-_-ACCLARIS%20SSO-_-ACCESS%20PRIOR%20PLAN%20YEAR',
                        target: 'acclarisWindow',
                        inputs: {
                            cookieData: success.data.payload.cookieData,
                            userName: success.data.payload.userName,
                            destinationURL: success.data.payload.destinationURL,
                            URLparms: success.data.payload.URLparms
                        }
                    };
                    invisibleForm.submit(ssoFormConfig);
                }, function (error) {
                    coremetrics.elementTag('MEMBER:CLAIMS AND SPENDING:ACCLARIS ERROR', 'MEMBER:CLAIMS AND SPENDING:SPENDING ACCOUNTS');
                });
            };
            $scope.heading = 'Educational Material';

        }])
};